import ProjectCard from '../components/ProjectCard';
import { Link } from 'react-router-dom';

export default function ProjectGrid(content: any) {

	return (
		<>
			<div className="row g-2 h-100 d-flex">
				{content.object.map((project: any) => {
					return (
						<div className="col-12 col-sm-4 col-md-4 col-lg-3" key={project.id}>
							<ProjectCard
								key={"proj" + project.id}
								title={project.property_name}
								image={project.images[0]}
								body={project.address}
								status={project.status}
								link={"/listings/" + project.slug}
							/>
						</div>
					)
				})}
				<div className="col-12 col-sm-8 col-md-8 col-lg-3 bg-primary d-flex align-items-center justify-content-center">
					<div className="card bg-transparent p-5">
						<Link to={content.link}><p className="fw-bolder text-secondary fs-2">{content.linkText} <i className="fas fa-chevron-right text-secondary"></i></p></Link>
					</div>
				</div>
			</div>
		</>
	)
}